const TOOL_LABELS: Record<string, string> = {
  // Revenue
  get_report_metadata: 'Reading report info',
  get_revenue_summary: 'Pulling revenue summary',
  get_customer_revenue_details: 'Pulling customer revenue',
  list_customers_by_revenue: 'Ranking customers by revenue',
  get_revenue_by_period: 'Pulling revenue by period',
  get_revenue_concentration: 'Analyzing revenue concentration',
  get_revenue_trends: 'Analyzing revenue trends',
  list_products_by_revenue: 'Ranking products by revenue',
  get_customer_monthly_revenue: 'Pulling monthly revenue',
  get_quarterly_revenue: 'Pulling quarterly revenue',
  get_revenue_by_currency: 'Pulling revenue by currency',
  get_revenue_by_line_item_type: 'Pulling revenue by line type',
  get_revenue_by_pricing_model: 'Pulling revenue by pricing model',
  get_revenue_statistics: 'Computing revenue statistics',
  filter_customers_by_revenue: 'Filtering customers by revenue',
  detect_revenue_anomalies: 'Scanning for revenue anomalies',
  get_renewal_suggestions: 'Pulling upcoming renewals',
  get_all_overdue_invoices: 'Pulling overdue invoices',
  get_customers_with_unbilled_revenue: 'Pulling unbilled revenue',
  get_waterfall_totals: 'Pulling waterfall totals',
  get_business_signals: 'Scanning business signals',
  get_contract_billing_details: 'Pulling contract billing details',

  // MRR
  get_mrr_summary: 'Pulling MRR summary',
  get_mrr_waterfall: 'Building MRR waterfall',
  get_mrr_churn_rate: 'Computing churn rate',
  get_mrr_top_movers: 'Finding top MRR movers',
  get_mrr_by_customer: 'Pulling MRR by customer',
  get_mrr_for_customer: 'Pulling customer MRR',
  get_mrr_by_currency: 'Pulling MRR by currency',
  get_mrr_by_product: 'Pulling MRR by product',
  get_mrr_by_product_per_customer: 'Pulling MRR by product per customer',
  get_mrr_trend: 'Analyzing MRR trend',
  get_mrr_forecast: 'Forecasting MRR',
  get_committed_vs_projected_arr: 'Comparing committed vs projected ARR',
  get_renewals_upcoming: 'Pulling upcoming renewals',
  get_mrr_concentration: 'Analyzing MRR concentration',
  get_mrr_health_metrics: 'Computing NRR / GRR',
  get_mrr_report_metadata: 'Reading MRR report info',

  // AR Health
  get_ar_health_summary: 'Pulling AR summary',
  get_aging_bucket_breakdown: 'Pulling AR aging',
  get_customer_aging_summary: 'Pulling customer AR aging',
  get_customer_overdue_details: 'Pulling customer overdue invoices',
  get_overdue_invoices_list: 'Pulling overdue invoices',
  get_collection_risk_assessment: 'Assessing collection risk',
  get_ar_health_trend: 'Analyzing AR trend',
  get_consistently_late_customers: 'Finding consistently late customers',

  // Customer Master
  get_customer_master_summary: 'Pulling customer summary',
  get_customers_by_status: 'Counting customers by status',
  get_customers_by_type: 'Counting customers by type',
  get_customers_by_currency: 'Counting customers by currency',
  get_customers_by_subsidiary: 'Counting customers by subsidiary',
  get_customers_by_payment_provider: 'Counting customers by payment provider',
  get_top_customers_by_mrr: 'Ranking top customers by MRR',
  get_customer_details: 'Pulling customer details',
  get_contracts_expiring: 'Pulling expiring contracts',
  get_renewal_pipeline_summary: 'Building renewal pipeline',
  get_customers_by_account_manager: 'Pulling AM book of business',
  get_data_quality_issues: 'Scanning data quality issues',
  get_customer_master_metadata: 'Reading customer master info',
};

function fallbackLabel(name: string): string {
  return name
    .replace(/[-_]/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase()
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
}

export function getFriendlyToolLabel(toolName: string): string {
  return TOOL_LABELS[toolName] ?? fallbackLabel(toolName);
}
